import React, { useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Spin } from 'antd';
import { doc, setDoc } from 'firebase/firestore';
import { firestore } from 'config/firebase';
import { useAuthContext } from 'contexts/AuthContext';

const { Option } = Select;

const ShippingAddress = ({ next }) => {
  const { user, dispatch } = useAuthContext();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(user?.address || null);

  const handleChange = (changedFields, allFields) => {
    const { value } = changedFields[0];
    setSelectedAddress((prev) => ({
      ...prev,
      [changedFields[0].name[0]]: value,
    }));
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await setDoc(doc(firestore, 'users', user.uid), {
        ...user,
        address: values,
      });
      dispatch({
        type: 'USER_UPDATE_PROFILE',
        payload: { user: { ...user, address: values } },
      });
      next();
    } catch (error) {
      console.error('Error saving address:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div>
            <h3 className="font-weight-600">Select a delivery address</h3>
            <p>
              Please select your delivery address or add a new one.
            </p>
            {user.address ? (
              <div
                className={`p-4 rounded-3 bg-light mb-4 ${selectedAddress ? 'border border-primary' : ''}`}
                onClick={() => setSelectedAddress(user.address)}
              >
                <h5>{user.address.name}</h5>
                <p className="mb-0">
                  {`${user.address.addressLine1}, ${user.address.addressLine2}, ${user.address.city}, ${user.address.state} ${user.address.pinCode}`}
                </p>
              </div>
            ) : (
              <p>No address found. Please add a new address.</p>
            )}
            {selectedAddress && (
              <div className="mb-4">
                <Button
                  type="primary"
                  className="px-5 py-3"
                  onClick={next}
                  disabled={loading}
                >
                  {loading ? <Spin /> : 'Deliver Here'}
                </Button>
              </div>
            )}
            <h2 className="font-weight-600">Add a new address</h2>
            <Form
              form={form}
              name="address"
              className="p-4 rounded-3 bg-light"
              onFinish={onFinish}
              onFieldsChange={handleChange}
              layout="vertical"
            >
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: 'Please input your name!' }]}
              >
                <Input placeholder="Enter Name" size="large" disabled={loading} />
              </Form.Item>

              <Form.Item label="Mobile Number" name="mobile" rules={[{ required: true, message: 'Please input your mobile number!' }, { pattern: /^[0-9]{10}$/, message: 'Mobile number must be exactly 10 digits!' },]}
              >
                <Input placeholder="Enter Mobile Number" size="large" disabled={loading} />
              </Form.Item>

              <Form.Item label="Flat, House no., Building, Company, Apartment" name="addressLine1" rules={[{ required: true, message: 'Please input your address!' }]}>
                <Input placeholder="Enter Address" size="large" disabled={loading} />
              </Form.Item>

              <Form.Item label="Area, Colony, Street, Sector, Village" name="addressLine2" rules={[{ required: true, message: 'Please input your area!' }]}>
                <Input placeholder="Enter Area" size="large" disabled={loading} />
              </Form.Item>

              <Form.Item label="City" name="city" rules={[{ required: true, message: 'Please select your city!' }]}>
                <Select placeholder="Select City" size="large" disabled={loading}>
                  <Option value="city1">City 1</Option>
                  <Option value="city2">City 2</Option>
                </Select>
              </Form.Item>

              <Form.Item label="Pin Code" name="pinCode" rules={[{ required: true, message: 'Please input your pin code!' }, { pattern: /^[0-9]{6}$/, message: 'Pin code must be exactly 6 digits!' },]}>
                <Input placeholder="Enter Pin Code" size="large" disabled={loading} />
              </Form.Item>

              <Form.Item label="State" name="state" rules={[{ required: true, message: 'Please select your state!' }]}>
                <Select placeholder="Select State" size="large" disabled={loading}>
                  <Option value="state1">State 1</Option>
                  <Option value="state2">State 2</Option>
                </Select>
              </Form.Item>

              <Form.Item name="defaultAddress" valuePropName="checked">
                <Checkbox disabled={loading}>Use as my default address</Checkbox>
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" size="large" className="w-100 bg-dark border-0 py-3" disabled={loading}>
                  {loading ? <Spin /> : 'Add New Address'}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingAddress;
